import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {NodeApiService} from '../../../../services/api/network/online/node/node-api.service';
import {ConnectionApiService} from '../../../../services/api/network/online/connection/connection-api.service';
import {VoipPeerApiService} from '../../../../services/api/network/online/voip-peer/voip-peer-api.service';
import {NetworkApiService} from '../../../../services/api/network/online/network/network-api.service';
import {QualityBasedRoutingApiService} from '../../../../services/api/settings/routing/quality-based-routing/quality-based-routing-api.service';
import {IpProfileApiService} from '../../../../services/api/network/online/ip-profile/ip-profile-api.service';
import {MediaRealmApiService} from '../../../../services/api/network/online/media-realm/media-realm-api.service';
import {PeerConnectionApiService} from '../../../../services/api/peer-connection/peer-connection-api.service';

@Injectable({
  providedIn: 'root'
})
export class DataCacheApiService {
  private dataReady = new BehaviorSubject<boolean>(false);

  pcons: any;
  nodes: any;
  connections: any;
  voipPeers: any;
  clusters: any;
  qualityBasedRouting: any;
  ipProfiles: any;
  mediaRealm: any;

  constructor(private peerConnectionsApiService: PeerConnectionApiService,
              private nodeApiService: NodeApiService,
              private connectionApiService: ConnectionApiService,
              private voipPeersApiService: VoipPeerApiService,
              private networkApiService: NetworkApiService,
              private qualityBasedRoutingApiService: QualityBasedRoutingApiService,
              private ipProfilesApiService: IpProfileApiService,
              private mediaRealmApiService: MediaRealmApiService) {
  }

  initData(): void {
    this.initDataNow().then(
      () => {
        this.dataReady.next(true);
      });
  }

  initDataNow(): Promise<any> {
    const resPcons = this.peerConnectionsApiService.getPCons().then(data => {
      this.pcons = data;
    });

    const resNodes = this.nodeApiService.getNodes().then(data => {
      this.nodes = data;
    });

    const resConnections = this.connectionApiService.getConnections().then(data => {
      this.connections = data;
    });

    const resPeerConnections = this.voipPeersApiService.getVoipPeers().then(data => {
      this.voipPeers = data.elements;
    });

    const resClusters = this.networkApiService.getClusters().toPromise().then(data => {
      this.clusters = data;
    });

    const resQualityBasedRouting = this.qualityBasedRoutingApiService.getQualityBasedRoutingSettings().toPromise().then(
      data => {
        this.qualityBasedRouting = data;
      });

    const resIpProfiles = this.ipProfilesApiService.getIpProfiles().toPromise().then(
      data => {
        this.ipProfiles = data;
      });

    const resMediaRealm = this.mediaRealmApiService.getMediaRealm().toPromise().then(
      data => {
        this.mediaRealm = data;
      });

    return Promise.all([resPcons, resNodes, resConnections, resPeerConnections,
      resClusters, resQualityBasedRouting, resIpProfiles, resMediaRealm]);
  }

  getDataReady(): BehaviorSubject<boolean> {
    return this.dataReady;
  }

  setDataReady(value: boolean): void {
    this.dataReady.next(value);
  }

  getPcons(): any {
    return this.pcons;

  }

  getNodes(): any {
    return this.nodes;
  }

  getConnections(): any {
    return this.connections;
  }

  getVoipPeers(): any {
    return this.voipPeers;
  }

  getClusters(): any {
    return this.clusters;
  }

  getQualityBasedRouting(): any {
    return this.qualityBasedRouting;
  }

  getIpProfiles(): any {
    return this.ipProfiles;
  }

  getMediaRealm(): any {
    return this.mediaRealm;
  }
}
